<template>
  <div>
    <div class="vx-row mt-5" v-if="(mainComplianceStatus === 'running' && !investorHasOperations) && isMounted">
      <div class="vx-col w-full h-auto">
        <compliance-running />
      </div>
    </div>

    <div class="vx-row mt-5" v-if="(mainComplianceStatus === 'completed' && !investorHasOperations) && isMounted">
      <div class="vx-col w-full h-auto">
        <fund-ready />
      </div>
    </div>

    <vx-card class="mt-5" v-if="(mainComplianceStatus === 'pending' && !investorHasOperations) && isMounted">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mb-1">
            <div class="flex flex-wrap items-center">
              <p class="card-sub-title mr-5" v-if="mverficationNoSuccessful">
                La verificación de identidad no fue exitosa.
              </p>
              <p class="card-sub-title mr-5" v-else>
                Verificación de identidad.
              </p>
            </div>
          </div>

          <p v-if="mProcessIsPending">
            El inversionista no ha iniciado el proceso de verificación con Mati.
          </p>
          <p v-if="mverficationNoSuccessful">
            El proceso de verificación del inversionista no ha sido exitoso. Deberá realizarlo nuevamente.
          </p>
        </div>
      </div>
    </vx-card>

    <forms-container
      v-if="isMounted"
      class="mt-4"
      :investor_id="InvestorId"
      :investor_status="InvestorStatus"
      :user_id="UserId"
      :moral-tabs="moralTabs"
      :pfae-tabs="pfaeTabs"
      :full-disabled="true"
    />
  </div>
</template>

<script>

import FormsContainer from "@components/profile_shared/FormsContainer";
import ComplianceRunning from "@components/compliance/ComplianceRunning";
import FundReady from "@components/compliance/FundReady";
import investorIdentityHelper from "@/helpers/investorIdentityHelper";
import investorInfoHelper from "@/helpers/investorInfoHelper";
import stpHelper from "@mixins/stpHelper";
export default {
  name: "AboutYou",
  components: {
    FormsContainer,
    ComplianceRunning,
    FundReady
  },
  mixins: [investorIdentityHelper, investorInfoHelper, stpHelper],
  data() {
    return {
      isMounted: false,
      identity: null,
      status: null,
      processWasStarted: false,
      pfaeTabs: ['general'],
      moralTabs: ['general','contact'],

      identityIsCompleted: false,
      investorHasOperations: false,
      isMoral: null,
      mainComplianceStatus: null,
      InvestorId: null,
      InvestorStatus: null,
      UserId: null,
      UserPersonType: null,
    }
  },
  beforeMount() {
    this.InvestorId = this.$route.params.id;
  },
  async mounted(){
    this.isMounted = false
    this.showLoading(true)
    await this.getInvestorInfo();
    await this.getIdentityInfo();
    await this.verifyCompliances();
    this.isMounted = true
    this.showLoading(false)
  },
  computed: {
    mProcessIsPending(){
      return this.matiIsPending(this.status);
    },
    mshouldRunMatiProcess(){
      return this.shouldRunMatiProcess(this.status);
    },
    mverificationIsCompleted(){
      return this.verificationIsCompleted(this.status);
    },
    mverificationIsRejected(){
      return this.verificationIsRejected(this.status);
    },
    mverificationIsInProcess(){
      return this.verificationIsInProcess(this.status);
    },
    mverificationisNewRequired(){
      return this.verificationisNewRequired(this.status);
    },
    mverificationIsReviewNeeded(){
      return this.verificationIsReviewNeeded(this.status);
    },
    mverficationNoSuccessful(){
      return this.mverificationIsRejected || this.mverificationisNewRequired || this.mverificationIsReviewNeeded;
    }
  },
  methods: {
    async reloadStatus(){
      this.showLoading(true)
      await this.getIdentityInfo();
      this.processWasStarted = false;
      this.showLoading(false)
    },
    async getInvestorInfo(){
      const requiredObjects = ['user'];
      const investor = await this.getInvestorData(this.InvestorId, requiredObjects);
      this.InvestorStatus = investor.status;
      this.UserId = investor.user.id;
      this.UserPersonType = investor.user.person_type;
    },
    async verifyCompliances(){
      // si el inversionista ya ha hecho operaciones, no se le muestra el banner
      if(this.InvestorStatus > 2){
        this.investorHasOperations = true;
        return;
      }

      // se verifica la identidad en general (ya sea p.fisica o p.moral)
      this.isMoral = this.userIsMoral(this.UserPersonType);
      let isForeign = this.userIsForeign(this.UserPersonType);

      // definir si mati esta pendiente o debe hacerse de nueva cuenta
      const shouldRunMati = this.shouldRunMatiProcess(this.status);
      if(shouldRunMati){
        this.mainComplianceStatus = "pending";
        return;
      }

      const matiIsRunning = this.matiIsRunning(this.status);
      if(matiIsRunning){
        this.mainComplianceStatus = "running";
        return;
      }

      // definir si esta completado
      const matiCompleted = this.verificationIsCompleted(this.status);
      if(this.isMoral || isForeign){
        if(matiCompleted){
          this.mainComplianceStatus = "completed";
        }
        else {
          this.mainComplianceStatus = "running";
        }
      }
      else {
        const stpClabe = await this.getInvestorAccountStpClabe(this.InvestorId);
        if(matiCompleted && stpClabe !== null){
          this.mainComplianceStatus = "completed";
        }
        else {
          this.mainComplianceStatus = "running";
        }
      }
    },
    async getIdentityInfo(){
      this.status = await this.getInvestorIdentityStatus(this.InvestorId);
      this.identityIsCompleted = this.verificationIsCompleted(this.status);
    },
  }
}
</script>

<style scoped>

</style>